import { createLogger } from '../../../common/infra/logger';

export const logger = createLogger('dynascore');
